import client from '../../components/sanityProject/sanityClient';
import { useProducts } from '../../context/ProductContext';
import { useEffect } from 'react';

const ProductsRealtimeListener = () => {
  const { fetchProducts } = useProducts();

  useEffect(() => {
    const sub = client
      .listen('*[_type=="product"]', {}, { events: ['create','update','delete','publish'] })
      .subscribe(() => fetchProducts());

    return () => sub.unsubscribe();
  }, [fetchProducts]);

  return null;
};

export default ProductsRealtimeListener;